import { ProjectDto } from '@/core';
import { useMemo } from 'react';
import { sort } from '@/utils';

export const usePositionsOptions = (projectData: ProjectDto) => {
  return useMemo(
    () =>
      projectData.positions
        .map((position) => ({ label: position.name, value: position.id }))
        .sort((a, b) => sort(a.label, b.label)),
    [projectData],
  );
};
